import { ServiceBase } from '../../../../core/services/ServiceBase'
import OwnershipAndGroupProxy from './OwnershipAndGroupProxy'

class OwnershipAndGroupService extends ServiceBase {
  getHighlights(params) {
    return this.getData(() => OwnershipAndGroupProxy.getHighlights(params))
  }
  getOwnershipDetail(params) {
    return this.getData(() => OwnershipAndGroupProxy.getOwnershipDetail(params))
  }
  getOwnershipHistorical(params) {
    return this.getData(() =>
      OwnershipAndGroupProxy.getOwnershipHistorical(params),
    )
  }
  getRelatedCompanyViewBy(params) {
    return this.getData(() =>
      OwnershipAndGroupProxy.getRelatedCompanyViewBy(params),
    )
  }
  downloadStructureMajorShareholder(params) {
    return this.getFileDownload(() =>
      OwnershipAndGroupProxy.downloadStructureMajorShareholder(params),
    )
  }
  downloadParentCompany(params) {
    return this.getFileDownload(() =>
      OwnershipAndGroupProxy.downloadParentCompany(params),
    )
  }
  downloadBranch(params) {
    return this.getFileDownload(() =>
      OwnershipAndGroupProxy.downloadBranch(params),
    )
  }
  downloadAssociatedCompany(params) {
    return this.getFileDownload(() =>
      OwnershipAndGroupProxy.downloadAssociatedCompany(params),
    )
  }
  downloadSubsidiary(params) {
    return this.getFileDownload(() =>
      OwnershipAndGroupProxy.downloadSubsidiary(params),
    )
  }
  downloadRelatedCompany(params) {
    return this.getFileDownload(() =>
      OwnershipAndGroupProxy.downloadRelatedCompany(params),
    )
  }
}

export default new OwnershipAndGroupService()
